import { getColorSchemePreference } from '@coursera-web/appearance';

import type { Client, Events, Plugin } from '@coursera/event-pulse/core';

/**
 * It is called before page view event and sets the color scheme to user profile.
 *
 * @param client
 */

function setColorSchemeOnPageViewt(client: Client) {
  return async (eventName: keyof Events) => {
    if (eventName !== 'view_page') {
      // We are only setting color scheme on page view events for now.
      return;
    }

    const systemSetToDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const courseraSetting = getColorSchemePreference();
    const isDarkModeRendered = courseraSetting === 'dark' || (courseraSetting === 'system' && systemSetToDark);
    await client.sendEvent('identify', {
      set: {
        prefersDarkColorScheme: systemSetToDark,
        colorSchemeRendered: isDarkModeRendered ? 'dark' : 'light',
      },
    });
  };
}

const plugin: Plugin = (client) => {
  client.on('beforeQueue', setColorSchemeOnPageViewt(client));
};

export { plugin };
